// import UI from 'nr.os-ui'

// const nros = UI.nros
import nros from "./nros.js";

/**对于$http的封装 */
let $http = nros.getPlugin("http");

let Ssologin = {};
Ssologin.ticketLogin = (url = "/sedu/sso/login") => {
  var windowHref = new URL(window.location.href.replace("#/", "")),
    newOption = "";
  if (windowHref.search) {
    //使用带有hash的链接获取service
    // var service = window.location.href.replace(windowHref.search, '')
    var service = window.osConfig.staticService;
    //在query参数中添加service
    windowHref.searchParams.append("service", service);
  }
  if (windowHref.search.length > 0) {
    let indexS = windowHref.search.charAt(0);
    if (indexS === "?") {
      newOption = windowHref.search.substring(1);
    }
  }
  if (newOption.indexOf("sedu_ticket") != -1) {
    url = "/sedu/sso/login/check";
  }
  return new Promise((resolve, reject) => {
    nros
      .getPlugin("login")
      .ssoLogin(newOption, url)
      .then(data => {
        $http.setHeaders(nros.getPlugin("login").getHeader());
        nros
          .getPlugin("login")
          .store(nros.getPlugin("config").getConfig().storageMode);
        // nros.getPlugin('http').get('/nvwa/getLoginContext').then(res => {
        //     GMS.userContext = res.data.context;
        //     nros.getPlugin('event').emit('set-user-success')
        //     resolve();
        // })
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
export { Ssologin };



// WEBPACK FOOTER //
// ./src/common/SsoLogin.js